/**
 * Investment Type Constants
 *
 * Defines all investment product type acronyms used throughout the application.
 * Uses modern TypeScript 'as const' pattern for type safety and tree-shaking.
 */

export const TipoInvestimento = {
    /** Renda Fixa - Fixed Income */
    RENDA_FIXA: "RF",

    /** Renda Variável - Variable Income/Stocks */
    RENDA_VARIAVEL: "RV",

    /** Consórcio - Consortium */
    CONSORCIO: "CS",

    /** Plano de Saúde - Health Insurance */
    PLANO_SAUDE: "PS",

    /** Crédito - Credit Products */
    CREDITO: "CR",

    /** Patrimônio - Wealth Management */
    PATRIMONIO: "PA",

    /** Previdência - Pension/Retirement */
    PREVIDENCIA: "PE",

    /** COE - Certificado de Operações Estruturadas */
    COE: "CO",

    /** Fundos - Investment Funds */
    FUNDOS: "FU",
} as const;

/**
 * Union type of all investment type values
 * Usage: const tipo: TipoInvestimentoValue = "RF";
 */
export type TipoInvestimentoValue = (typeof TipoInvestimento)[keyof typeof TipoInvestimento];
